import axios from "axios";

export const api = axios.create();

api.interceptors.response.use(
	(response) => response.data,
	(error) => {
		return Promise.reject(error);
	}
);

export const upload = (signatureUrl, imageBuffer, contentType) => {
	return api.put(signatureUrl, imageBuffer, {
		headers: {
			"Content-Type": contentType,
			// OSS Bucket 私有化后，PUT 预签名统一带 x-oss-object-acl: private，
			// 请求头必须与签名时一致，否则校验失败
			"x-oss-object-acl": "private",
		},
	});
};
export const uploadVideo = (signatureUrl, imageBuffer, contentType) => {
	return api.put(signatureUrl, imageBuffer, {
		headers: {
			"Content-Type": contentType,
			"x-oss-object-acl": "private",
		},
	});
};
